
import { connect } from 'react-redux'
import CardTotalSpotsComponent from '../components/CardTotalSpotsComponent'

const mapStateToProps = ({ display }) => ({
    dsp: display.dsp,
    programmatic: display.programmatic,
})

export default connect(mapStateToProps)(CardTotalSpotsComponent)